import * as React from 'react';

import useUrlState from '@ahooksjs/use-url-state';
import { useBoolean, useLockFn } from 'ahooks';
import { Button, Form, Input, notification, Typography } from 'antd';

import { MobileOutlinedIcon, PrimitiveForm } from 'components';
import { useLoginAction, useLoginValue } from 'context';
import { sendSigninOtp } from 'services';
import { inputRule, PATHNAME } from 'utils';

const {
  QUERY_PARAM: {
    TYPE: { BASE_URL: TYPE_BASE_URL },
  },
} = PATHNAME;

type FieldType = Required<
  Pick<ReturnType<typeof useLoginValue>, 'phoneNumber'>
>;

const LoginPhoneNumberForm = () => {
  const [, setUrlState] = useUrlState(
    {
      [TYPE_BASE_URL]: '',
    },
    { navigateMode: 'replace' },
  );
  const [loading, { toggle: toggleLoading }] = useBoolean();
  const [form] = Form.useForm<FieldType>();
  const action = useLoginAction();

  const onFinish = useLockFn(async ({ phoneNumber }: FieldType) => {
    toggleLoading();

    sendSigninOtp({ phoneNumber })
      .then(({ ticket }) => {
        action({
          type: 'UPDATE_LOGIN_IDENTITY',
          payload: { phoneNumber, ticket },
        });
        action({ type: 'UPDATE_LOGIN_STEP', payload: { step: 2 } });
      })
      .catch(message => {
        notification.error({ message });
      })
      .finally(() => {
        toggleLoading();
      });
  });

  return (
    <div className='basis-1/2 space-y-8'>
      <Typography.Title level={2} className='text-center text-2xl'>
        ورود با رمز یک‌بار مصرف
      </Typography.Title>
      <PrimitiveForm form={form} onFinish={onFinish}>
        <Form.Item<FieldType>
          label='شماره همراه'
          name='phoneNumber'
          rules={[inputRule.required, inputRule.phoneNumber]}
        >
          <Input
            placeholder='شماره همراه را وارد کنید'
            prefix={
              <MobileOutlinedIcon className='text-lg text-[--ant-color-text-placeholder]' />
            }
          />
        </Form.Item>
        <Form.Item className='mb-4'>
          <Button block type='primary' htmlType='submit' loading={loading}>
            ادامه
          </Button>
        </Form.Item>
        <Form.Item className='mb-0'>
          <Button
            block
            onClick={() => {
              setUrlState({ [TYPE_BASE_URL]: undefined });
            }}
          >
            ورود با رمز ثابت
          </Button>
        </Form.Item>
      </PrimitiveForm>
    </div>
  );
};

export { LoginPhoneNumberForm };
